import { flagError } from 'error-handling'
import {
  FORM_SLUG,
  FORMS_OPTIN_PARAM,
  FORMS_OPTIN_VALUE,
  formsMode,
  monthlySlug,
  readsDrupal,
  type DrupalMonthly,
} from '~/libs/formsDrupal'

const FORMS_ROUTE_TIMEOUT_MS = 4000

/**
 * The Drupal Månadsgivare form for a slug (looked up lowercased), or null, as useDrupalDonation:
 * the mode doesn't read Drupal for this request, not published there, a preview, or the route
 * failed. The page then reads Contentful.
 */
export const useDrupalMonthly = async (
  rawSlug: string,
  lang: string,
  isPreview: boolean,
  optedIn: boolean,
): Promise<DrupalMonthly | null> => {
  const slug = monthlySlug(rawSlug)
  const mode = formsMode(useRuntimeConfig().public.FORMS_DRUPAL)
  if (isPreview || !readsDrupal(mode, optedIn) || !FORM_SLUG.test(slug)) return null
  const { $rollbar } = useNuxtApp()
  const query = optedIn ? { [FORMS_OPTIN_PARAM]: FORMS_OPTIN_VALUE } : undefined
  const { data } = await useAsyncData(
    `forms-monthly-${mode}${optedIn ? '-optin' : ''}-${lang}-${slug}`,
    () =>
      $fetch<DrupalMonthly | null>(`/api/forms/monthly/${lang}/${slug}`, {
        query,
        timeout: FORMS_ROUTE_TIMEOUT_MS,
      })
        .then(found => found || null)
        .catch(error => {
          flagError(error, 'forms/route', import.meta.client ? $rollbar : undefined, {
            lang,
            slug,
            type: 'monthly',
            formsMode: mode,
          })
          return null
        }),
    { deep: false },
  )
  return data.value ?? null
}
